import React from 'react';
import './Header.css';
import ThemeToggle from './theme-toggle/ThemeToggle';
import { getDomainConfig } from '../utils/domainConfig';

const Header = ({ theme, onSelectCategory, toolsCount, streamersCount, activeSection }) => {
  const { siteName } = getDomainConfig();

  return (
      <header className={`site-header ${theme}`}>
        <div className="header-inner">
          <h1 className="site-title">{siteName}</h1>
          <nav className="header-nav">
            <button
                className={`nav-tab ${activeSection === 'tools' ? 'active' : ''}`}
                onClick={() => onSelectCategory('tools')}
            >
              Tools <span className="nav-count">{toolsCount}</span>
            </button>
            <button
                className={`nav-tab ${activeSection === 'streamers' ? 'active' : ''}`}
                onClick={() => onSelectCategory('streamers')}
            >
              Streamers <span className="nav-count">{streamersCount}</span>
            </button>
            <a
                className="nav-tab support-tab"
                href="https://ko-fi.com/giorgosart"
                target="_blank"
                rel="noopener noreferrer"
            >
              ☕ Support
            </a>
          </nav>
          <ThemeToggle />
        </div>
      </header>
  );
}

export default Header;
